import React from 'react';
import { getClientOrigins } from '../../api';
import GenericAssigner from './GenericAssigner';

const ClientOriginAssigner = ({
  order,
  onClientOriginChange,
  multiSelect = false,
  selectedOrderIds = [],
  preChargedClientOrigins
}) => {
  return (
    <GenericAssigner
      order={order}
      onChange={onClientOriginChange}
      multiSelect={multiSelect}
      selectedOrderIds={selectedOrderIds}
      preChargedOptions={preChargedClientOrigins}
      fetchOptions={getClientOrigins}
      fieldName="clientOriginId"
      displayField="name"
      valueField="valueId"
    />
  );
};

export default ClientOriginAssigner;